module.exports = __webpack_public_path__ + "img/text-pic.ced09257.png";